<div [hidden]="!active" class="pane background" [style.background-color]="background">
	<ng-content></ng-content>
</div>
